// @flow

import type {IntegerType} from "./model";


type ProductConfigType = {
    lineCount: IntegerType,
    addPoints: IntegerType,
    hudPoints: IntegerType,
    adasAreasCount: IntegerType,
    angleCount: IntegerType
};


class ProductConfig {
    /**
     * Joonte arv
     */
    lineCount: IntegerType;
    /**
     * HUD punktide arv
     */
    hudPoints: IntegerType;
    /**
     * Täiendavate punktide arv keskmisel joonel
     */
    addPoints: IntegerType;
    /**
     * ADAS piirkondade arv
     * @type {IntegerType}
     */
    adasAreasCount: IntegerType;

    /**
     * Nurganominaalide arv
     * @type {IntegerType}
     */
    angleCount: IntegerType;

    constructor(state: ProductConfigType) {
        this.lineCount = (state.lineCount ? state.lineCount : 3);
        this.hudPoints = (state.hudPoints ? state.hudPoints : 0);
        this.addPoints = (state.addPoints ? state.addPoints : 0);
        this.adasAreasCount = (state.adasAreasCount ? state.adasAreasCount : 0);
        this.angleCount = (state.angleCount ? state.angleCount : 1);
    }

    isEqual(other: ProductConfig): boolean {
        return this.lineCount === other.lineCount &&
            this.hudPoints === other.hudPoints &&
            this.addPoints === other.addPoints &&
            this.adasAreasCount === other.adasAreasCount &&
            this.angleCount === other.angleCount;
    }
}

export {ProductConfig as default, ProductConfigType};
